import { useState, useEffect, useRef } from "react"
import nodeApiService from "../../services/nodeApiService"
import styles from "../../features/pages/ArtworkDetailPage/ArtworkDetailPage.module.css"
import { getArtworkSize } from "../../services/utils/getArtworkSize"

export const useArtworkDetailsActions = (artwork, insertArplacerButtons) => {
  const recaptchaRef = useRef()
  const [form, setForm] = useState({
    email: "",
    firstname: "",
    lastname: "",
    body: "",
  })
  const [modal, setModal] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState([])
  const [success, setSuccess] = useState(false)
  const [size, setSize] = useState(null)

  const handleClose = () => {
    setModal(false)
    setTimeout(() => {
      setSuccess(false)
    }, 500)
  }
  const handleShow = () => {
    setSuccess(false)
    setModal(true)
  }
  const onSubmit = (event) => {
    event.preventDefault()
    recaptchaRef.current.execute()
  }
  const successCallback = () => {
    setSuccess(true)
    setForm({
      email: "",
      firstname: "",
      lastname: "",
      body: "",
    })
  }
  const onReCAPTCHAChange = async (captchaCode) => {
    if (!captchaCode) {
      return
    }
    setError(false)
    nodeApiService
      .inquire(artwork.id, {
        ...form,
        captcha: captchaCode,
        channel: "discover",
        type: "artwork_inquiry_discover",
      })
      .then(
        (_) => {
          successCallback()
        },
        (res) => {
          setError(true)
          setErrorMessage(res.response.data.errorMessage)
        },
      )
    recaptchaRef.current.reset()
  }

  useEffect(() => {
    setSize(getArtworkSize(artwork.width, artwork.height))
    insertArplacerButtons ? insertArplacerButtons() : null
  }, [artwork])

  return {
    form,
    setForm,
    modal,
    handleClose,
    handleShow,
    onSubmit,
    error,
    errorMessage,
    success,
    size,
    onReCAPTCHAChange,
    recaptchaRef,
  }
}
